import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./banner";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function AboutPage() {
  return (
    <>
      {/* Banner */}
      <section className="banner text-white py-5">
        <div className="container">
          <div className="row align-items-center">

            {/* Text */}
            <div className="col-lg-5 text-center pt-5 mt-5 text-lg-start mb-4 mb-lg-0">
              <h1 className="display-5 fw-bold">
                About Us
              </h1>

              <p className="text-white-50">
                Our factory tour provided valuable insights into the manufacturing process and showcased cutting-edge technology in action. Got a firsthand glimpse of how raw materials transform into finished brilliance. Pretty cool to see industry in motion!
              </p>

              
            </div>

            {/* Image */}
            <div className="col-lg-7 text-center">
              <img
                src="images/factoryimg.png"
                alt="couch"
                className="img-fluid banner-img"
              />
            </div>

          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <div className="why-choose-section">
      <div className="container">
        <div className="row justify-content-between">

          {/* Left Content */}
          <div className="col-lg-6">
            <h2 className="section-title">Why Businesses Choose Us</h2>
            <p>
               We provide reliable manufacturing solutions with
              advanced machinery, premium quality materials,
              and strong production support for businesses worldwide.
            </p>

            <div className="row my-5">

              {/* Feature 1 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/171923/factory.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Advanced Manufacturing</h3>
                  <p>Modern production facilities ensuring
                    precision and consistent quality output.</p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://staging.svgrepo.com/show/94814/quality.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Premium Quality Products</h3>
                  <p>High-grade materials and strict quality
                    control for long-lasting durability.</p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/48151/team-support.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Dedicated Business Support</h3>
                  <p>Professional assistance and customized
                    solutions tailored for your business needs.</p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/116369/earth-globe-tool.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Reliable Global Supply</h3>
                  <p>Efficient logistics and timely delivery
                    for domestic and international clients.</p>
                </div>
              </div>

            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-5">
            <div className="img-wrap">
              <img
                src="/images/factory.png"
                alt="why choose us"
                className="img-fluid"
              />
            </div>
          </div>

        </div>
      </div>
    </div>

      {/* Manufacturing */}
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="fw-bold mb-5">Some Of Our Manufacturing Machines</h2>

          <div className="row">
            {[
              { name: "Cross-Cut Machine", img: "crosscutmachine.png" },
              { name: "Double-Side Planer", img: "doublesideplaner.png" },
              { name: "Overhead Router", img: "overheadrouter.png" },
              { name: "Rip Saw Machine", img: "ripsawmachine.png" },
            ].map((member, i) => (
              <div className="col-md-6 col-lg-3 mb-4" key={i}>
                <img
                  src={`images/${member.img}`}
                  alt={member.name}
                  className="img-fluid rounded mb-3"
                />
                <h6 className="fw-bold">{member.name}</h6>
                
              </div>
            ))}
          </div>
        </div>
      </section>

      
      {/* Testimonials */}
 <section className="testimonial-section py-5 text-white">

  <div className="container">

    <div className="text-center mb-5">

      <h2 className="fw-bold">
        What Our Clients Say
      </h2>

      <p className="mt-3">
        Trusted by furniture retailers, wholesalers,
        and interior brands across global markets.
      </p>

    </div>

    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={30}
      slidesPerView={1}
      loop={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      navigation
      pagination={{ clickable: true }}
      breakpoints={{
        768: { slidesPerView: 1 },
        992: { slidesPerView: 2 },
      }}
    >

      {[
        {
          name: "Michael Carter",
          role: "Furniture Importer",
          image: "/images/person-1.png",
          text: "PAAB INDIA delivered exceptional craftsmanship and premium quality furniture exactly as promised. Their professionalism and timely delivery exceeded our expectations.",
        },

        {
          name: "Sophia Williams",
          role: "Interior Design Brand",
          image: "/images/person-1.png",
          text: "The product quality, packaging standards, and communication throughout the process were outstanding. Highly recommended for global furniture sourcing.",
        },

        {
          name: "Daniel Smith",
          role: "Retail Store Owner",
          image: "/images/person-1.png",
          text: "We have been working with PAAB INDIA for multiple projects and their consistency in quality and service has always been impressive.",
        },

      ].map((item, index) => (

        <SwiperSlide key={index}>

          <div className="testimonial-card text-center">

            <p>
              “{item.text}”
            </p>

            <img
              src={item.image}
              alt={item.name}
              className="rounded-circle my-3"
              width="80"
            />

            <h6 className="fw-bold mb-0">
              {item.name}
            </h6>

            <small>
              {item.role}
            </small>

          </div>

        </SwiperSlide>

      ))}

    </Swiper>

  </div>

</section>
    </>
  );
}